// @flow
import './MetadataTimelineSidebarRow.css';

import * as React from 'react';
import classNames from 'classnames';
import ExpandButton from '../common/ExpandButton';
import Button from '../common/Button';
import { DEFAULT_ENGINE_NAME } from '../store/Constants';
import { ThemeSetup } from '../themes/ThemeSetup';
import _ from 'lodash';
const debug = require('../debug/debug')('wc:video:MetadataTimelineSidebarRow');

type Props = {
  data: Object,
  child?: boolean,
  isExpanded?: boolean,
  isDisabled?: boolean,
  isHovered?: boolean,
  isClicked?: Boolean,
  isActive: boolean,
  onToggle?: Function,
  onDisable?: Function,
  onMouseEnter?: Function,
  onMouseLeave?: Function,
  onToggleActiveRow: ?Function,
  onRowClick?: Function
};

type State = {};

export default class MetadataTimelineSidebarRow extends React.PureComponent<Props, State> {
  _node: ?HTMLDivElement;

  static extractLabelAndLength(data: any): { label: ?string, len: number } {
    let label: ?string;
    let len: ?number;
    // if (Array.isArray(data)) {
    //   len = data.length;
    //   label = data[0].object.label;
    // } else {
    //   len = data.value.length;
    //   label = len > 1 ? data.value[0][0].jsondata.sourceEngineName : data.value[0].jsondata.sourceEngineName;
    // }
    len = data.groupName;
    label = data.label ? data.label : data.groupName;
    if (_.size(label) === 0) {
      if (_.isString(data.key)) {
        label = _.startCase(data.key);
      }
    }
    return { label: label, len: len };
  }

  render() {
    const {
      data,
      child,
      isExpanded,
      isDisabled,
      isHovered,
      isClicked,
      isActive,
      onToggle,
      onDisable,
      onToggleActiveRow,
      onMouseEnter,
      onMouseLeave,
      onRowClick
    } = this.props;

    //let { label, len } = MetadataTimelineSidebarRow.extractLabelAndLength(data);
    //let len, label;
    // if (Array.isArray(data)) {
    //   len = data.length;
    //   label = data[0].object.label;
    // } else {
    //   len = data.value.length;
    //   label = len > 1 ? data.value[0][0].jsondata.sourceEngineName : data.value[0].jsondata.sourceEngineName;
    // }
    const { label, len } = MetadataTimelineSidebarRow.extractLabelAndLength(data);
    if (!label) {
      label = DEFAULT_ENGINE_NAME;
    }

    const props: Object = {
      name: 'MetadataTimelineSidebarRow',
      className: ''
    };

    if (!child && !isDisabled) {
      props.className += classNames({ ' hover': isHovered, clicked: isClicked });
      props.style = { height: isExpanded ? 36 * len : '', color: data.color };
      props.onMouseEnter = () => onMouseEnter(data);
      props.onMouseLeave = onMouseLeave;
      props.onClick = (e: MouseEvent) => (e.ctrlKey || e.metaKey ? '' : onRowClick(data));
    }

    return (
      <div {...props}>
        <header>
          {!child && len > 1 ? (
            <span>
              <ExpandButton isExpanded={isExpanded} onClick={() => onToggle(data.key)} />
            </span>
          ) : null}
          {onDisable ? (
            <TimelineNameButton
              disabled={isDisabled}
              onClick={(e: MouseEvent) => (e.ctrlKey || e.metaKey ? onDisable(data.key) : '')}
              label={label}
              tooltipStyle={{ maxWidth: !child ? `calc(100% - ${len > 1 ? 35 : 15}px)` : '' }}
              style={{ width: '100%' }}
            />
          ) : null}
          {child ? (
            <TimelineNameButton
              disabled={isDisabled}
              onClick={(e: MouseEvent) => (onDisable && (e.ctrlKey || e.metaKey) ? onDisable(data.key) : '')}
              label={label}
              tooltipStyle={{ maxWidth: !child ? `calc(100% - ${len > 1 ? 35 : 15}px)` : '' }}
              style={{ width: '100%' }}
            />
          ) : (
            <ActiveTimeLineButton
              isActive={isActive}
              onClick={() => (onToggleActiveRow ? onToggleActiveRow(data.items, label) : null)}
            />
          )}
          {/* {child ? (
            <Button
              type="PLAIN"
              className={classNames({ disabled: isDisabled })}
              onClick={() => onDisable(data.key)}
              style={{ maxWidth: !child ? `calc(100% - ${len > 1 ? 35 : 15}px)` : '' }}
              labelClass="label"
              title={label}>
              {label}
            </Button>
          ) : null} */}
        </header>
        {isExpanded ? (
          <div className="children">
            {data.value.slice(1).map((o, i) => (
              <MetadataTimelineSidebarRow key={i} data={o} child />
            ))}
          </div>
        ) : null}
      </div>
    );
  }
}

type TimelineNameButtonProp = {
  disabled: ?boolean,
  onClick: ?Function,
  label: string,
  style: Object
};
class TimelineNameButton extends React.PureComponent<TimelineNameButtonProp> {
  render() {
    return (
      <Button
        type="PLAIN"
        className={classNames({ disabled: this.props.disabled })}
        onClick={this.props.onClick}
        style={this.props.style}
        tooltipStyle={this.props.tooltipStyle}
        labelClass="label"
        title={this.props.label}>
        {this.props.label}
      </Button>
    );
  }
}

type ActiveTimeLineButtonProp = {
  isActive: boolean,
  onClick: ?Function
};
class ActiveTimeLineButton extends React.PureComponent<ActiveTimeLineButtonProp> {
  //Pure component. Need to use simple props only.
  //This is eye icon, when enabled we display the timeline values in the video as captions else not.
  render() {
    const icon: string = this.props.isActive
      ? ThemeSetup.getImageURL('eye_black.svg')
      : ThemeSetup.getImageURL('eye_gray.svg'); //`images/eye_${this.props.isActive ? 'black' : 'gray'}.svg`;
    return (
      <Button
        type="PLAIN"
        icon={icon}
        className={classNames('eye-icon', { active: this.props.isActive })}
        onClick={this.props.onClick}
      />
    );
  }
}
